// Centralized content & assets for the Nine Furlongs landing page

export const CONTACT = {
  phone: "+91 98765 43210",
  phoneHref: "tel:+919876543210",
  whatsapp: "https://wa.me/919876543210",
  email: "reservations@ninefurlongs.com",
  address: "Nine Furlongs Estate, Binsar Valley, Almora, Uttarakhand 263624",
  mapLink: "https://maps.google.com/?q=Binsar+Almora+Uttarakhand",
};

export const IMAGES = {
  logo: "/brand/logo.png",
  heroBackground: "/brand/index-pic-1.jpg",
  heroSlides: [
    "/brand/index-pic-1.jpg",
    "/brand/index-pic-5.jpg",
    "/brand/index-pic-3.jpg",
    "/brand/index-pic-4.jpg",
  ],
  estateExterior: "/brand/contact-7.jpg",
  estateNature: "/brand/mg0406.jpg",
  roomInterior1: "/brand/slide3.jpg",
  roomInterior2: "/brand/index-pic-3.jpg",
  dining: "/brand/index-pic-4.jpg",
  himalayanView: "/brand/index-pic-5.jpg",
};

export const STATS = [
  { value: "8,000 ft", label: "Above sea level" },
  { value: "150+ Acres", label: "Private forest estate" },
  { value: "1950s", label: "Heritage legacy" },
  { value: "300°", label: "Himalayan panorama" },
];

export const STAYS = [
  {
    name: "The Forest Suite",
    desc: "Floor-to-ceiling windows opening onto a private deck above the oak canopy. Wake to birdsong and a sea of clouds.",
    image: IMAGES.roomInterior1,
    tag: "Most loved",
  },
  {
    name: "Heritage Bungalow",
    desc: "A restored colonial-era cottage with a working fireplace, antique interiors and uninterrupted valley views.",
    image: IMAGES.roomInterior2,
    tag: "Private cottage",
  },
  {
    name: "Fireside Dining",
    desc: "Slow, seasonal Kumaoni cuisine served under the stars — foraged greens, smoked meats and mountain honey.",
    image: IMAGES.dining,
    tag: "Experience",
  },
];

export const FEATURES = [
  {
    icon: "TreePine",
    title: "Deep Forest Solitude",
    desc: "150 acres of private, undisturbed Himalayan oak and rhododendron forest — yours to wander.",
  },
  {
    icon: "Mountain",
    title: "300° Himalayan Views",
    desc: "Panoramas of the snow-clad Nanda Devi range from every room, deck and dining table.",
  },
  {
    icon: "Landmark",
    title: "Living Heritage",
    desc: "A restored 1950s estate steeped in the music, history and folklore of the Binsar valley.",
  },
  {
    icon: "Utensils",
    title: "Slow Mountain Cuisine",
    desc: "Hyper-local Kumaoni menus crafted from the estate's own orchards and forest harvest.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The most peaceful four days of our lives. You hear nothing but the wind and the birds. We left feeling like new people.",
    name: "Ananya & Rohan",
    from: "Mumbai",
  },
  {
    quote:
      "Waking up above the clouds with the Himalayas glowing pink at dawn is something I will never forget. Faultless service.",
    name: "Sarah Whitfield",
    from: "London",
  },
  {
    quote:
      "A rare, soulful place. The heritage, the forest, the food — every detail is considered. Truly a hidden gem of Almora.",
    name: "Vikram Mehta",
    from: "Delhi",
  },
];

export const FAQS = [
  {
    q: "Where exactly is Nine Furlongs located?",
    a: "We are nestled inside the Binsar valley near Almora, Uttarakhand, at roughly 8,000 ft. The estate is about a 2-hour drive from Kathgodam railway station and a 90-minute drive from Pantnagar airport.",
  },
  {
    q: "What is the best time to visit?",
    a: "The estate is beautiful year-round. March–June offers blooming rhododendrons and clear mountain views, while September–November brings crisp air and the sharpest Himalayan panoramas.",
  },
  {
    q: "Is the stay all-inclusive?",
    a: "Our packages include luxury accommodation, all meals featuring local Kumaoni cuisine, guided forest walks and stargazing. Custom experiences can be arranged on request.",
  },
  {
    q: "How do I make a reservation?",
    a: "Simply fill out the enquiry form or call us directly. Our reservations team will craft a personalised itinerary and confirm availability within a few hours.",
  },
];
